// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import less from 'less'
import router from './router'
import VueVideoPlayer from 'vue-video-player'
import * as echarts from 'echarts'
import $ from 'jquery'
import Vant from 'vant';
import 'vant/lib/index.css';


import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import 'videojs-flash'
import '@/assets/theme.css'

import VueDPlayer from "vue-dplayer"
import "vue-dplayer/dist/vue-dplayer.css"
import SIPAudio from '@/components/audio/SIPAudio.js'
import store from './store'

Vue.use(VueDPlayer)

Vue.prototype.$echarts = echarts

Vue.use(VueVideoPlayer)
Vue.use(less)
Vue.use(ElementUI)
Vue.use(SIPAudio)

Vue.use(Vant)

Vue.config.productionTip = false

// 过滤
Vue.filter('timeString', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.substring(0,10)
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js